import * as React from 'react';
import styled from 'styled-components';
import { NHLAPI } from '../modules/NHLAPI';
const settings = require('../settings.json');
const allTeams = require('../allTeams.json');
class DraftPlayerStatLine extends React.Component {
    constructor() {
        super(...arguments);
        this.nhl = new NHLAPI();
    }
    render() {
        let statLine = React.createElement(Container, null);
        if (this.props.player) {
            console.log("PLAY FOR STAT LINE:", this.props.player);
            const player = this.props.player;
            const position = settings.positionMap[this.props.player.position].type;
            let fields = undefined;
            let stats = undefined;
            if (settings.statMap[position]) {
                const statMap = settings.statMap[position];
                fields = Object.keys(statMap).map((key) => {
                    return (React.createElement("th", { key: player.id + "_field_" + key }, statMap[key].abbr));
                });
                stats = Object.keys(statMap).map((key) => {
                    return (React.createElement("td", { key: player.id + key }, player.stats[key]));
                });
            }
            statLine = (React.createElement(Container, null,
                React.createElement("img", { width: "100", height: "100", src: this.nhl.playerProfileImage(player.id), alt: player.fullName }),
                React.createElement("div", null,
                    React.createElement("h3", null,
                        player.fullName,
                        " (",
                        allTeams[player.currentTeamId].abbreviation,
                        ")"),
                    React.createElement("table", null,
                        React.createElement("thead", null,
                            React.createElement("tr", null, fields)),
                        React.createElement("tbody", null,
                            React.createElement("tr", null, stats))))));
        }
        return statLine;
    }
}
;
export default DraftPlayerStatLine;
const Container = styled.div `
  background-color: rgba(0,0,0,0.5);
  border-bottom: 1px solid #666;
  box-sizing: border-box;
  min-height: 122px;
  padding: 10px

  img, div {
    display: inline-block;
    vertical-align: top;
  }

  div {
    margin-left: 20px;
  }

  h3 {
    margin: 7px;
  }

  table {
    text-align: left;
  }

  th, td {
    padding: 5px 10px;
  }

  th {
    background-color: rgba(95, 50, 6, 0.6)
  }

  td {
    background-color: rgba(255,255,255,0.2);
  }
`;
//# sourceMappingURL=DraftPlayerStatLine.js.map


// WEBPACK FOOTER //
// ./src/components/DraftPlayerStatLine.js